import { render, staticRenderFns } from "./WarehousWeight.vue?vue&type=template&id=02a71a20&scoped=true"
import script from "./WarehousWeight.vue?vue&type=script&lang=js"
export * from "./WarehousWeight.vue?vue&type=script&lang=js"
import style0 from "./WarehousWeight.vue?vue&type=style&index=0&id=02a71a20&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a71a20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02a71a20')) {
      api.createRecord('02a71a20', component.options)
    } else {
      api.reload('02a71a20', component.options)
    }
    module.hot.accept("./WarehousWeight.vue?vue&type=template&id=02a71a20&scoped=true", function () {
      api.rerender('02a71a20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/automaticSortings/WarehousingWeight/WarehousWeight.vue"
export default component.exports